import Vue from 'vue'
import Router from 'vue-router'
import CyclingMobileGame from '@/components/CyclingMobileGame'
import TotalMobileRanking from '@/components/TotalMobileRanking'
import TotalRanking from '@/components/TotalRanking'
import CyclingApply from '@/components/CyclingApply'
import CyclingPadRanking from '@/components/CyclingPadRanking'

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: 'CyclingPadRanking',
        component: CyclingPadRanking
    }, {
        path: '/m-rttt-4',
        name: 'CyclingMobileGame',
        component: CyclingMobileGame
    }, {
      path: '/m-rttt-4-rank',
      name: 'TotalMobileRanking',
      component: TotalMobileRanking
    }, {
        path: '/pc-rttt-4',
        name: 'CyclingApply',
        component: CyclingApply
    }, {
        path: '/pad-rttt-4',
        name: 'CyclingPadRanking',
        component: CyclingPadRanking
    }, {
        path: '/pc-rttt-4-rank',
        name: 'TotalRanking',
        component: TotalRanking
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js